import { render, staticRenderFns } from "./RoutingkeySelect.vue?vue&type=template&id=0640f796"
import script from "./RoutingkeySelect.vue?vue&type=script&lang=js"
export * from "./RoutingkeySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports